import { o2oApi } from 'yxt-biz-pc/packages/api';

/**
 * 获取项目信息
 * @param {String} formId
 * @returns {Promise} 项目信息
 */
export const getAuditDetail = formId => o2oApi.get(`subTask/audit/form/info?formId=${formId}`);
